module.exports = __webpack_public_path__ + "media/images/ofn-o-10e781691a67b9837621458f1cf095dc.png";